export enum PriceCalculationType {
    MANUAL = "MANUAL",
    WORK_TYPE_UNIT_PRICING = "WORK_TYPE_UNIT_PRICING"
}
